/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Paket_TInputs */

const en_tut_paket_t = /** @type {(inputs: Tut_Paket_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans, invoices, and add-ons`)
};

const id_tut_paket_t = /** @type {(inputs: Tut_Paket_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket, tagihan, dan add-on`)
};

/**
* | output |
* | --- |
* | "Plans, invoices, and add-ons" |
*
* @param {Tut_Paket_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_paket_t = /** @type {((inputs?: Tut_Paket_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Paket_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_paket_t(inputs)
	return en_tut_paket_t(inputs)
});